var _circle, _circle2, _circle3, _path, _path2, _circle4, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFaqIcon5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 60,
    viewBox: "0 0 103 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 29.3,
    fill: "white",
    stroke: "#475467",
    strokeWidth: 1.4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.0015,
    cy: 30,
    r: 4.5,
    fill: "white",
    stroke: "#475467",
    strokeWidth: 1.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.0015,
    cy: 30,
    r: 4.5,
    fill: "white",
    stroke: "#475467",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5015 0.75H31.5015V4.5C31.5015 5.32843 30.8299 6 30.0015 6C29.173 6 28.5015 5.32843 28.5015 4.5V0.75Z",
    fill: "#475467"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4985 59.25L28.4985 59.25L28.4985 55.5C28.4985 54.6716 29.1701 54 29.9985 54C30.827 54 31.4985 54.6716 31.4985 55.5L31.4985 59.25Z",
    fill: "#475467"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 88,
    cy: 28,
    r: 14.5,
    fill: "white",
    stroke: "#D0D5DD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M93.0932 23.7119C94.1 24.719 94.7855 26.002 95.0631 27.3986C95.3408 28.7953 95.198 30.2429 94.653 31.5584C94.108 32.8739 93.1851 33.9983 92.0011 34.7894C90.817 35.5805 89.425 36.0027 88.001 36.0027C86.5771 36.0027 85.1851 35.5805 84.001 34.7894C82.817 33.9983 81.8941 32.8739 81.3491 31.5584C80.8041 30.2429 80.6613 28.7953 80.939 27.3986C81.2166 26.002 81.9021 24.719 82.9089 23.7119",
    stroke: "#AFAFAF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0044 20V28.0003",
    stroke: "#AFAFAF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqIcon5);
export default __webpack_public_path__ + "static/media/faq-icon5.df09a63a907c0f58cb9356bbc47c9942.svg";
export { ForwardRef as ReactComponent };